import { Dispatch, SetStateAction } from 'react';
import { IInvoice, IContact } from 'types';
import { ContactButton } from './ContactCell.styles';
import { ParagraphWithEllipsis } from '../Typography/Typography';
import ContactReviewStatus from '../ContactReviewStatus/ContactReviewStatus';
import { isReceivableInvoice } from 'utils/invoices';

interface OwnProps {
  recipientToUse?: IContact;
  setContactForEdit?: Dispatch<SetStateAction<IContact>>;
  setInvoiceForAddContact?: Dispatch<SetStateAction<IInvoice>>;
  invoice: IInvoice;
}

const ContactCell: React.FC<OwnProps> = ({
  recipientToUse,
  setContactForEdit,
  setInvoiceForAddContact,
  invoice,
}) => (
  <ContactButton
    as="button"
    disabled={!recipientToUse}
    onClick={(e) => {
      e.stopPropagation();

      // contacts with ID from invoices
      if (invoice.contactId && recipientToUse?.enabled && recipientToUse?.id) {
        setContactForEdit?.(recipientToUse);
        // contacts without ID from OrderWise
      } else if (recipientToUse) {
        setInvoiceForAddContact?.(invoice);
      }
    }}
  >
    <ParagraphWithEllipsis
      style={{
        textDecoration: recipientToUse ? 'underline' : 'none',
      }}
    >
      {recipientToUse?.recipientName ?? 'Contact is missing'}
    </ParagraphWithEllipsis>

    {!isReceivableInvoice(invoice) && recipientToUse && (
      <ContactReviewStatus contact={recipientToUse} />
    )}
  </ContactButton>
);

export default ContactCell;
